import { Atom, Landmark, BookOpen, Sprout, Info } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

const STANDARDS = [
  { name: "NGSS & California NGSS", icon: Atom, color: "bg-mint",
    text: "Shape how we plan science inquiry: asking questions, investigating, using models and evidence, and linking ideas across the sciences." },
  { name: "California History–Social Science Standards", icon: Landmark, color: "bg-blush",
    text: "Guide the historical and geographical thinking in our Social Studies & Humanities units: sources, time, place and perspective." },
  { name: "Common Core State Standards", icon: BookOpen, color: "bg-sky",
    text: "Inform the reading, writing, speaking and mathematical reasoning students use to research, explain and argue in every project." },
  { name: "The New Zealand Curriculum", icon: Sprout, color: "bg-lavender",
    text: "Keeps learning relevant to Aotearoa. Its key competencies and learning areas help us connect projects to students' lives here." },
];

export const StandardsSection = () => (
  <section className="section-y" aria-labelledby="standards-title" data-testid="standards-section">
    <div className="container-x">
      <SectionHeading id="standards-title" eyebrow="Curriculum planning" title="Grounded in recognised curriculum standards"
        intro="We draw on respected international and New Zealand frameworks when we plan what students learn and how skills build over time." />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STANDARDS.map(({ name, icon: Icon, color, text }, i) => (
          <Reveal key={name} delay={i * 0.08} as="article" className="h-full">
            <div className="card-soft flex h-full flex-col p-7 transition-transform duration-300 hover:-translate-y-1" data-testid={`standard-card-${i}`}>
              <span className={`grid h-12 w-12 place-items-center rounded-2xl ${color}`}><Icon className="h-6 w-6" aria-hidden="true" /></span>
              <h3 className="mt-5 text-xl font-semibold leading-snug">{name}</h3>
              <p className="mt-3 text-ink-soft leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 flex max-w-3xl items-start gap-2 text-sm leading-relaxed text-ink-muted" data-testid="standards-note">
        <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        These frameworks are reference points for our curriculum planning. MUCCI Academy is an independent provider and does not claim
        accreditation by, or full compliance with, any standards body.
      </p>
    </div>
  </section>
);
